// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"171":"zxing","235":"capture","240":"scan","927":"imports"}[chunkId] || chunkId) + "." + {"171":"906d6f8b","235":"39328284","240":"47dfb354","432":"bca85d44","927":"04180047"}[chunkId] + ".chunk.js";
};